import { User } from '../../models/user/user.model';
import { USERS_COLLECTION } from '../paths/user.path';
import { getCollectionRef } from '../utils/firestore.refs';
import { CollectionReference, doc, DocumentReference, Firestore } from '@angular/fire/firestore';

//
// User
//
export function getUsersCol(firestore: Firestore): CollectionReference<User> {
  return getCollectionRef<User>(firestore, USERS_COLLECTION);
}

export function getUserRef(firestore: Firestore, userId: string): DocumentReference<User> {
  const col = getUsersCol(firestore);
  return doc(col, userId);
}
